import React from "react";
import { Link } from "react-router-dom";

const Disclaimers = () => {
	return (
		<p className="text-xs leading-8 py-5 text-gray-400">
			Welcome to my digital playground. <br />
			This portfolio serves as my personal sandbox, changes may occur from time
			to time. <br />
			For inquiries, feel free to contact me via the social media links provided
			or{" "}
			<Link
				to="/contact"
				className="cursor-pointer text-blue-600 bold">
				<span>send me an email or message</span>
			</Link>
			.
		</p>
	);
};

export default Disclaimers;
